import { baseEnvironment } from './environment.base';

/**
 * Purpose: Angular build configuration variant used for the Linux / Kubernetes build.
 * Inherits environment.base.ts and overrides it with Linux-specific configuration.
 * Build command: `npm run build:prod:linux`.
 * See `angular.json` for how this file is wired to the build command and configuration.
 */
export const environment = {
  ...baseEnvironment,
  manifestFile: 'linux.mf.manifest.json',
};
